export default {
  en: {
    home: "Home",
    incoming_calls_count: "Incoming Call",
    calls_count: "Total Calls",
    tickets_count: "Tickets",
    call: "Call",
    ticket_number: "Ticket Number",
    tickets: "Tickets",
    status: "Status",
    average_speed_of_answer: "ASA",
    average_talk_time: "ATT",
    missed_calls_count: "Missed Calls",
    average_hold_time: "AHT",
    seconds: "seconds",
    abandoned_calls_rate: "Abandoned Calls Rate",
    first_call_resolution_rate: "First Call Resolution Rate",
    satisfaction_rate: "Customer Satisfaction Rate",
    service_level_rate: "Service Level Rate",
    performance_indicator: "Daily Performance Indicator",
    social_media_messages: "Social Media Messages",
    latest_internal_conversations: "Latest Internal Conversations",
    call_log: "Calls Log",
    show_all: "Show All",
    show_log: "Show Log",
    outgoing_calls: "Outgoing Calls",
    no_social_media_messages: "No Social Media Messages",
    no_internal_conversations: "No Internal Conversations found",
    no_calls_history: "No Calls found",
    avg_handle_time: "Avg Handle Time",
    avg_waiting_time: "Avg Wait Time",
    answered_calls: "Answered Calls",
    first_call_resolved: "FCR",
    sec: "sec",
    abandoned_calls: "Abandoned Calls",
    incoming_calls: "Incoming Calls",
    agent_summary: {
      incoming: "INCOMING",
      outgoing: "OUTGOING",
      staff: "STAFF",
      talk_time: "Talk time",
      staff_time: "Working time",
      call_count: "call",
      login_count: "login",
      answered: "Answered",
      abandoned: "Abandoned",
      avg_waiting_time: "Avg Waiting Time",
    },
    agent_status: {
      online_status: "Online",
      offline_status: "Offline",
      rest_status: "Rest",
      minutes: "{n} minute | {n} minutes",
      busy_status: "Not Ready",
      skill_choose: "Queue choose",
      forward_hint: "number to forward calls to",
      not_ready_status: "Not Ready",
      open_status: "No time limit",
      not_ready_status_reason: {
        meeting: "Meeting",
        training: "Training",
        other: "Other",
      },
    },
    main_summary: {
      total_calls: "Total Calls",
      success_calls: "Success Calls",
      failed_calls: "Failed Calls",
      users: "Users",
      traffic: "Traffic",
      taffic_day_title: "Incoming/Outgoing calls at {day}",
      traffic_hours_title: "Hours",
    },
    calls_history: {
      title: "Last Calls History",
      mdn: "MDN",
      time: "Time",
      duration: "Duration",
      call_type: "Call Type",
      call_reason: "Call Reason",
      incoming_call_type: "incoming",
      outgoing_call_type: "outgoing",
      internal_call_type: "internal",
    },
    caller_last_reasons: {
      title: "Last call reasons for {caller}",
      agent: "Agent",
      time: "Time",
      call_reason: "Call Reason",
      satisfaction: "Satisfaction",
      add_reason_btn: "Add Call reason",
      set_reason_call_btn: "Attach Reasons To The Call",
      satisfied_check: "Satisfied",
      not_satisfied_check: "Not Statisfied",
    },
    caller_last_tickets: {
      title: "Support Tickets",
      agent: "Agent",
      time: "Time",
      ticket_name: "Ticket Name",
      ticket_date: "Ticket Date",
      ticket_status: "Ticket Status",
      add_ticket_btn: "Open Ticket",
      no_last_tickets: " No Previous Tickets Found",
    },
    caller_info: {
      title: "Basic info for customer {caller}",
      no_info_message: "There is no current info on this Number",
      create_account_btn: "Create Account",
      display_account_btn: "View Account",
      refresh_account_btn: "Refresh",
      mandatory_field_msg: "Field {field} is Mandatory",
      invalid_field_msg: "Field {field} is Invalid",
      new_ticket_title: "New Ticket",
      open_ticket_btn: "Open Ticket",
    },
  },
  ar: {
    home: "الرئيسية",
    incoming_calls_count: "عدد المكالمات الواردة",
    calls_count: "عدد المكالمات",
    tickets_count: "عدد التذاكر",
    call: "مكالمة",
    ticket_number: "تذكرة رقم",
    tickets: "التذاكر",
    status: "الحالة",
    abandoned_calls_rate: "معدل عدم الرد على المكالمات",
    first_call_resolution_rate: "معدل معالجة البلاغ من مرة واحدة",
    satisfaction_rate: "درجة رضا العميل",
    service_level_rate: "معدل مستوى الخدمة",
    average_speed_of_answer: "متوسط سرعة الاستجابة",
    average_talk_time: "متوسط مدة المكالمة",
    missed_calls_count: "عدد المكالمات التي لم يرد عليها",
    average_hold_time: "متوسط نسبة الانتظار قبل الرد",
    seconds: "ثانية",
    performance_indicator: "مؤشر الأداء اليومي",
    social_media_messages: "رسائل وسائل التواصل الاجتماعي",
    latest_internal_conversations: "أخر المحادثات الداخلية",
    call_log: "سجل المكالمات",
    show_all: "عرض الجميع",
    show_log: "عرض السجل",
    outgoing_calls: "المكالمات الصادرة",
    no_social_media_messages: "لا توجد رسائل من وسائل التواصل الاجتماعي",
    no_internal_conversations: "لا توجد محادثات داخلية",
    no_calls_history: "لا توجد مكالمات",
    avg_handle_time: "متوسط زمن المعالجة",
    avg_waiting_time: "متوسط زمن الانتظار",
    answered_calls: "المكالمات المجابة",
    first_call_resolved: "حل من المرة الأولى",
    sec: "ثانية",
    abandoned_calls: "المكالمات الفائتة",
    incoming_calls: "المكالمات الواردة",
    agent_summary: {
      incoming: "الواردة",
      outgoing: "الصادرة",
      staff: "الدوام",
      talk_time: "المحادثة",
      staff_time: "فترة العمل",
      call_count: "مكالمة",
      login_count: "دخول",
      answered: "مجابة",
      abandoned: "فائتة",
      avg_waiting_time: "متوسط زمن الانتظار",
    },
    agent_status: {
      online_status: "متصل",
      offline_status: "غير متصل",
      rest_status: "استراحة",
      minutes:
        "لا دقائق | دقيقة واحدة | دقيقتان | {n} دقائق | {n} دقيقة | {n} دقيقة",
      busy_status: "غير مستعد",
      skill_choose: "إختيار مجموعة",
      forward_hint: "رقم تحويل المكالمات",
      not_ready_status: "غير مستعد",
      open_status: "لا يوجد حد للوقت",
      not_ready_status_reason: {
        meeting: "اجتماع",
        training: "تدريب",
        other: "أخرى",
      },
    },
    main_summary: {
      total_calls: "كل المكالمات",
      success_calls: "المكالمات الناجحة",
      failed_calls: "المكالمات الفاشلة",
      users: "المستخدمين",
      traffic: "حركة المكالمات",
      taffic_day_title: "المكالمات الواردة/الصادرة ليوم {day}",
      traffic_hours_title: "الساعات",
    },
    calls_history: {
      title: "سجل آخر المكالمات",
      mdn: "رقم المتصل",
      time: "الزمن",
      duration: "المدة",
      call_type: "نوع المكالمة",
      call_reason: "سبب المكالمة",
      incoming_call_type: "واردة",
      outgoing_call_type: "صادرة",
      internal_call_type: "داخلية",
    },
    caller_last_reasons: {
      title: "سجل آخر أسباب مكالمات للمتصل {caller}",
      agent: "الموظف",
      time: "الزمن",
      call_reason: "سبب المكالمات",
      satisfaction: "درجة الرضا",
      add_reason_btn: "إضافة سبب إتصال",
      set_reason_call_btn: "إلحاق الأسباب للمكالمة",
      satisfied_check: "راضي",
      not_satisfied_check: "غير راضي",
    },
    caller_last_tickets: {
      title: "تذاكر الدعم الفني",
      agent: "الموظف",
      time: "الزمن",
      ticket_name: "اسم التذكرة",
      ticket_date: "تاريخ التذكرة",
      ticket_status: "حالة التذكرة",
      add_ticket_btn: "فتح تذكرة",
      no_last_tickets: "لا توجد بلاغات سابقة",
    },
    caller_info: {
      title: "بيانات المتصل {caller}",
      no_info_message: "لا توجد بيانات حاليا للرقم المتصل",
      create_account_btn: "تسجيل جديد",
      display_account_btn: "إستعراض",
      refresh_account_btn: "تحديث",
      mandatory_field_msg: "حقل {field} إلزامي",
      invalid_field_msg: "حقل {field} غير صحيح",
      new_ticket_title: "تذكرة جديدة",
      open_ticket_btn: "فتح التذكرة",
    },
  },
};
